// extracted by mini-css-extract-plugin
export default {"servicesHeaderContainer":"styles_servicesHeaderContainer__KfSsI"};